export default __webpack_public_path__ + "media/projects/red2-30a62577.svg";